"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAENavbar = void 0;

var _react = _interopRequireDefault(require("react"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _FAENavbarSearchSection = require("../FAENavbarSearchSection/FAENavbarSearchSection");

var _FAENavbarItemsSection = require("../FAENavbarItemsSection/FAENavbarItemsSection");

var _Notifications = _interopRequireDefault(require("@material-ui/icons/Notifications"));

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _FAEDropdown = require("../FAEDropdown/FAEDropdown");

var _FAEText = require("../FAEText/FAEText");

require("./FAENavbar.scss");

var _FAEAutoComplete = require("../FAEAutoComplete/FAEAutoComplete");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// libs
// src
// src
// scss
const FAENavbar = _ref => {
  let {
    isLogin,
    dropDownInfo,
    expertLogo,
    itemsList,
    userName,
    userNameClicked,
    expertLogoClicked,
    signInClicked,
    signUpClicked,
    ordersClicked,
    userCountry,
    notificationsList,
    searchResults = [],
    getSearchValue: _getSearchValue = () => {},
    getSelectedValue: _getSelectedValue = () => {},
    renderOption,
    mobileMenu = [],
    expertMobileLogo
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar"
  }, /*#__PURE__*/_react.default.createElement(_FAENavbarSearchSection.FAENavbarSearchSection, {
    placeholder: "What services are you looking for...",
    barIcon: /*#__PURE__*/_react.default.createElement(_Search.default, null),
    expertLogo: expertLogo,
    expertLogoClicked: expertLogoClicked,
    signInClicked: signInClicked,
    signUpClicked: signUpClicked,
    isLogin: isLogin,
    userCountry: userCountry,
    searchResults: searchResults,
    getSearchValue: value => _getSearchValue(value),
    getSelectedValue: value => _getSelectedValue(value),
    renderOption: renderOption
  }), /*#__PURE__*/_react.default.createElement(_FAENavbarItemsSection.FAENavbarItemsSection, {
    isLogin: isLogin,
    dropDownInfo: dropDownInfo,
    itemsList: itemsList,
    userName: userName,
    userNameClicked: userNameClicked,
    ordersClicked: ordersClicked,
    notificationsList: notificationsList,
    expertLogo: expertLogo,
    expertLogoClicked: expertLogoClicked,
    userCountry: userCountry,
    mobileMenu: mobileMenu
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--nav-bar-items-for-mobile-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-items-for-mobile-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-items-logo-for-mobile-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      cursor: "pointer"
    },
    onClick: expertLogoClicked,
    src: expertMobileLogo,
    alt: "Expert",
    width: "30px",
    height: "auto"
  }), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    bold: true,
    style: {
      fontSize: "9px"
    },
    paragraph: true,
    primary: true
  }, userCountry)), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-search-section-search"
  }, /*#__PURE__*/_react.default.createElement(_FAEAutoComplete.FAEAutoComplete, {
    type: "search",
    onChange: e => _getSearchValue(e.target.value),
    primary: true,
    placeholder: "What services are you looking for...",
    values: searchResults,
    shadowBoxProps: {
      className: "auto-complete-search-bar"
    },
    getSelectedValue: value => _getSelectedValue(value),
    value: {
      label: ""
    },
    renderOption: renderOption
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--mobile-nav-bar-actions-wrapper"
  }, isLogin && /*#__PURE__*/_react.default.createElement(_FAEDropdown.FAEDropdown, {
    primary: true,
    list: notificationsList,
    icon: /*#__PURE__*/_react.default.createElement(_Notifications.default, {
      style: {
        fontSize: "30px",
        color: "white"
      }
    })
  }), /*#__PURE__*/_react.default.createElement(_FAEDropdown.FAEDropdown, {
    primary: true,
    list: mobileMenu,
    icon: /*#__PURE__*/_react.default.createElement(_Menu.default, {
      style: {
        fontSize: "30px",
        color: "white"
      }
    })
  })))));
};

exports.FAENavbar = FAENavbar;